import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import { DetailsTableRow, getRecordValue } from './detailsTableRow';
import { DetailsTableDataTypeWithKey, IDetailsTableProps } from './types';

export const DetailsTable = <T, K>({
  columns,
  data,
  title,
  parentContext = {},
  userSite,
}: IDetailsTableProps<T, K>): JSX.Element | null => {
  const { i18n } = useTranslation();
  const { accountStore } = useMobxStore();
  const headerTextContext = { utcOffsetInHours: accountStore.generalSettings.utcOffsetInHours };

  if (!data) {
    return null;
  }

  return (
    <div className={userSite ? '' : 'summary-table'}>
      {title && <div className="summary-table__title">{i18n.t(title as KeyMapKeys)}</div>}
      <div className="summary-table__rows">
        {columns.map((col, index) => {
          const rowKey = `${col.key}${index}`;

          if (
            col.key === 'args' &&
            // @ts-ignore
            (!Object.keys((data as unknown as DetailsTableDataTypeWithKey<T>)[col.key]) ||
              // @ts-ignore
              !Object.keys((data as unknown as DetailsTableDataTypeWithKey<T>)[col.key]).length)
          ) {
            return null;
          }

          if (
            col.isHidden &&
            !(typeof col.isHidden === 'function' && !col.isHidden(data, getRecordValue(data, col.key), parentContext))
          ) {
            return null;
          }

          return <DetailsTableRow<T, K> col={col} key={rowKey} data={data} headerTextContext={headerTextContext} />;
        })}
      </div>
    </div>
  );
};

export default observer(DetailsTable);
